export default __webpack_public_path__ + "macbook_sm.ccf5a77d.png";